import React from 'react';

import DarkModeIcon from '@mui/icons-material/DarkMode';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { Box, ListItemText, Switch } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { logoutActions } from 'common/utils/helpers/session';

import * as profileConfigurationActions from '../../../modules/profileConfiguration/actions';

import StyledMenuItem from './StyledComponents/StyledMenuItem';

const ProfileMenuItems = ({
    handleClose,
    match,
    profileValues,
    redirect,
    saveConfig,
    selectedTheme,
    setTheme,
}) => {
    const { t } = useTranslation();
    const handleOnSwitchTheme = (e) => {
        const theme = e.target.checked ? 'dark' : 'light';
        setTheme(theme);
        saveConfig({ mode: theme });
    };

    return (
        <>
            <StyledMenuItem
                onClick={() => {
                    handleClose();
                    redirect('/profile/general');
                }}
                selected={match.path === '/profile'}
            >
                <PersonIcon />
                <ListItemText
                    primary={`${profileValues?.first_name} ${profileValues?.last_name}`}
                />
            </StyledMenuItem>

            <Box hidden>
                <StyledMenuItem>
                    <DarkModeIcon />
                    <ListItemText primary={t('Dark mode')} />
                    <Switch
                        checked={selectedTheme === 'dark'}
                        onChange={handleOnSwitchTheme}
                    />
                </StyledMenuItem>
            </Box>

            <StyledMenuItem
                onClick={() => {
                    handleClose();
                    logoutActions();
                }}
            >
                <LogoutIcon />
                <ListItemText primary={t('Logout')} />
            </StyledMenuItem>
        </>
    );
};

ProfileMenuItems.propTypes = {
    handleClose: PropTypes.func,
    match: PropTypes.object,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    saveConfig: PropTypes.func,
    setTheme: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    saveConfig: (config) =>
        dispatch(profileConfigurationActions.saveConfig(config)),
});

export default compose(connect(null, mapDispatchToProps))(ProfileMenuItems);
